import React from 'react'
import './Driving.css'
import DrivingImg from '../images/driving.jpg'

function Driving() {
    return (
        <div className='driving'>
            <img src= {DrivingImg} alt="" />
        </div>
    )
}

export default Driving
